import React from "react";
import Header from "../../component/Header/Header";

const Home = () => {
  return (
    <div>
      <Header />
      {/* <HomeBody /> */}
    </div>
  );
};

export default Home;
